import React from "react";

import Joi from "joi-browser";
import Form from "../common/Form";

import db from "../../services/query";
import lbl from "../../data/Labels.json";

import {PopUpContext} from "../../contexts/popUpContext";

class StudentEducationalInfoForm extends Form {
    static contextType = PopUpContext;

    state = {
        drp: {
            city: [],
            supporter: [],
        },
        data: {
            school_name: "",
            graduation_year: "",
            gov_kankor_id: "",
            gov_kankor_year: "",
            gov_kankor_score: "",
        },
        errors: {},
    };

    componentDidMount = async () => {
        const {drp, data} = this.state;
        const {
            popUp: {cache, edit},
        } = this.context;

        if (edit) {
            data.school_name = edit.school_name;
            data.graduation_year = edit.graduation_year;
            data.gov_kankor_id = edit.gov_kankor_id;
            data.gov_kankor_year = edit.gov_kankor_year;
            data.gov_kankor_score = edit.gov_kankor_score;
            data.aria_kankor_score = edit.aria_kankor_score;
        }

        this.setState({drp, data});
    };

    schema = {
        school_name: Joi.string().max(64),
        graduation_year: Joi.number(),
        gov_kankor_id: Joi.string().max(64),
        gov_kankor_year: Joi.number(),
        gov_kankor_score: Joi.number(),
        aria_kankor_score: Joi.number(),
    };

    doSubmit = async (e) => {
        const {togglePopUp, popUp} = this.context;
        const student_id = popUp.student.student_id;

        let __controls = this.cleanObject({
            student_id: popUp?.cache,
            ...this.state.data,
        });

        try {
            if (popUp?.edit?.id) {
                await db
                    .edit(`students/${student_id}/info/${popUp.edit.id}`, __controls)
                    .then(() => {
                        togglePopUp({form: "toast"});
                    })
                    .catch((e) => {
                        togglePopUp({
                            form: "toast",
                            message: e.toString(),
                            type: "warning",
                        });
                    });
            } else {
                await db
                    .save(`students/${student_id}/info`, __controls)
                    .then(() => {
                        togglePopUp({form: "toast"});
                    })
                    .catch((e) => {
                        togglePopUp({
                            form: "toast",
                            message: e.toString(),
                            type: "warning",
                        });
                    });
            }
            if (popUp.callback) popUp.callback();

        } catch ({response}) {
            if (response && response.status === 400) {
                const errors = {...this.state.error};

                this.setState({errors});
            }
        }
    };

    render() {
        const {data, drp} = this.state;
        const {popUp} = this.context;

        console.log(popUp);

        return (
            <div className="form-container">
                <form className="form crud" onSubmit={this.handleSubmit}>
                    <div className="head">
                        <p>{popUp?.edit ? lbl.EditStudentEducationalInfo : lbl.AddStudentEducationalInfo}</p>
                    </div>
                    <div className="form-inputs">
                        <div className="multi-input">
                            {this.renderInput("school_name", "نام مکتب", "text")}
                            <div className="pad"/>
                            {this.renderInput("graduation_year", "سال فراغت", "text")}
                        </div>
                        <div className="multi-input">
                            {this.renderInput("gov_kankor_year", "سال اشتراک در کانکور", "text")}
                            <div className="pad"/>
                            {this.renderInput("gov_kankor_id", "آیدی کانکور", "text")}
                        </div>
                        <div className="multi-input">
                            {this.renderInput("gov_kankor_score", " نمره کانکور ملی", "text")}
                            <div className="pad"/>
                            {this.renderInput("aria_kankor_score", "نمره کانکور آریا", "text")}
                        </div>

                    </div>
                    <div className="form-buttons">
                        {this.renderButton(popUp?.edit ? lbl.Edit : lbl.Save)}
                    </div>
                </form>
            </div>
        );
    }
}

export default StudentEducationalInfoForm;
